export default "__VITE_ASSET__CM$qjylV__"